<template>
  <v-container fluid>

    <TableItems
        ref="table_pratiche"
        model-name-prop="Pratica"
        :sort_by="['Stato','Cod']"
        :loadItemsOnCreated="true"
        :showTopToolbar="true"
        :show-title="false"
        :show-refresh-btn="false"
        :show-new-btn="false"
    >
    </TableItems>
  </v-container>
</template>
<style>
</style>

<script>
import TableItems from "@/views/TableItems.vue";


export default {
  components: {TableItems},

  computed: {},
  data: () => (
      {

  }),


  methods: {

  },

};
</script>


